// TODO: Moved this config to app config and use it only as a default fall back
export const DEFAULT_FEATURE_QUICK_SEARCH_ORDER_CONFIG = [
  "amenity.information",
  "occupant.currencyexchange",
  "amenity.atm",
  "amenity.wheelchair",
  "amenity.restroom",
  "amenity.restroom.male",
  "amenity.restroom.female",
  "amenity.exhibit",
  "amenity.landmark",
  "amenity.parking",
  "amenity.parking.shortterm",
  "amenity.parking.motorcycle",
  "amenity.parking.longterm",
  "amenity.parking.waitingarea",
  "amenity.parking.compact",
  "amenity.parking.ev",
  "amenity.privatelounge",
  "amenity.rideshare",
  "amenity.valet",
  "amenity.guestservices",
  "amenity.taxi",
  "amenity.groundtransportation",
  "amenity.bus",
  "amenity.bus.muni",
  "amenity.shuttle",
  "amenity.parking.bicycle",
  "amenity.smokingarea",
  "amenity.meetingpoint",
  "amenity.elevator",
  "amenity.escalator",
  "amenity.firstaid",
  "amenity.prayerroom",
  "amenity.stairs",
  "amenity.ticketing",
  "amenity.boardinggate.ferry",
  "amenity.coinlocker",
  "amenity.powerchargingstation",
  "amenity.wheelchairassit",
  "amenity.lostandfound",
  "amenity.foodservice",
  "amenity.businesscenter",
  "amenity.emergencyshelter",
  "amenity.prayerroom.buddhism",
  "amenity.defibrillator",
  "amenity.drinkingfountain",
  "amenity.handsanitizerstation",
  "amenity.unspecified",
  "amenity.entry",
  "amenity.fireextinguisher",
  "amenity.security",
  "amenity.seating",
  "amenity.copymachine",
  "amenity.fieldofplay",
  "amenity.fieldofplay.soccer",
  "amenity.amphitheater",
  "amenity.hoteling",
  "amenity.rail.muni",
  "occupant.donationcenter",
  "opening.emergencyexit",
]
